import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["monthlyButton", "annualButton", "priceRow"]

  // Class sets are configurable so the same controller serves the Bootstrap
  // marketing page (defaults) and Civic Warmth views, which pass
  // data-toggle-active-classes-value / data-toggle-inactive-classes-value.
  static values = {
    activeClasses: { type: String, default: "btn-primary" },
    inactiveClasses: { type: String, default: "btn-outline-light text-white" }
  }

  connect() {
    // Annual-first pricing (2026-07 restructure): default to the annual
    // interval; the button classes are set here so the markup doesn't need
    // to hardcode which toggle starts active.
    this.setActive(this.annualButtonTarget, this.monthlyButtonTarget)
    this.updatePriceDisplay('year')
  }

  toggleMonthly() {
    this.setActive(this.monthlyButtonTarget, this.annualButtonTarget)
    this.updatePriceDisplay('month')
  }

  toggleAnnual() {
    this.setActive(this.annualButtonTarget, this.monthlyButtonTarget)
    this.updatePriceDisplay('year')
  }

  setActive(activeButton, inactiveButton) {
    const active = this.activeClassesValue.split(' ').filter(Boolean)
    const inactive = this.inactiveClassesValue.split(' ').filter(Boolean)

    activeButton.classList.add(...active)
    activeButton.classList.remove(...inactive)

    inactiveButton.classList.remove(...active)
    inactiveButton.classList.add(...inactive)

    activeButton.setAttribute('aria-pressed', 'true')
    inactiveButton.setAttribute('aria-pressed', 'false')
  }

  updatePriceDisplay(interval) {
    this.priceRowTargets.forEach(row => {
      const rowInterval = row.dataset.interval
      if (rowInterval === interval) {
        row.style.display = ''
      } else {
        row.style.display = 'none'
      }
    })
  }
}
